<section class="flat-case-study s3 banner-section s4  " id="portfolio">
    <div class="container">
      <div class="d-md-flex">
        <div class="col-left animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">
          <div class="image-link t2">

            <div class="flat-title t2 mg-b60">
              <h4 class="sub-title mg-b13">Portfolio</h4>
              <h2 class="title-section color-d11 mg-b20">Few selected works.</h2>
              <p class="color-d13">
  
              </p>
            </div>
            <div class="pd-right">
              <div class="image-link t2">
                <div class="featured-post">
                  <a href="https://github.com/Samexao-Devs/AlwaysVacant"><img style="border-radius: 20px;" src="assets/images/section/Always Vacant.JPG" alt="images"></a>
                </div>
              </div>
              <div class="image-link t2">
                <div class="featured-post">
                  <a href="https://github.com/Naeliza/Naeliza-s-Hospital-system"><img style="border-radius: 20px;" src="assets/images/section/Naeliza's Hospital center.JPG" alt="images"></a>
                </div>
              </div>
            </div>
          </div>

        <!--   </div>
          <div class="image-link t2">
            <div class="featured-post">
              <a href="https://github.com/Samexao-Devs/AlwaysVacant"><img style="border-radius: 20px;" src="assets/images/section/Always Vacant.JPG" alt="images"></a>
            </div>
          </div>
          <div class="fl-btn text-center"> -->

          </div>
        </div>
        <div class="flat-spacer" data-desktop="0" data-mobile="100" data-smobile="100"></div>
        <div class="col-right animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
          <!-- <div class="flat-title t2 mg-b60">
            <h4 class="sub-title mg-b13">Portfolio</h4>
            <h2 class="title-section color-d11 mg-b20">Few selected works.</h2>
            <p class="color-d13">

            </p>
          </div>
          <div class="pd-right">
            <div class="image-link t2">
              <div class="featured-post">
                <a href="https://github.com/Samexao-Devs/AlwaysVacant"><img style="border-radius: 20px;" src="assets/images/section/Always Vacant.JPG" alt="images"></a>
              </div>
            </div>
            <div class="image-link t2">
              <div class="featured-post">
                <a href="https://github.com/Naeliza/Naeliza-s-Hospital-system"><img style="border-radius: 20px;" src="assets/images/section/Naeliza's Hospital center.JPG" alt="images"></a>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>